<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-8 text-center">
      <ng-container *ngIf="state === 'loading'">
        <h2>{{ 'INSCRIPTIONS.CancelInMail.LoadingTitle' | translate }}</h2>
        <p>{{ 'INSCRIPTIONS.CancelInMail.LoadingText' | translate }}</p>
      </ng-container>
    </div>
  </div>
</div>

